export default [
  {
    url: "/canalanonimo",
    name: "Fale com a Gestão",
    slug: "CanalAnonimo",
    icon: "AlertTriangleIcon"
  },
  {
    url: "/contingencia",
    name: "Contingência NFe/NFCe",
    slug: "contingencia",
    icon: "AlertTriangleIcon"
  },
  {
    url: null,
    name: "Administração",
    slug: "administracao",
    icon: "ZapIcon",
    submenu: [
      {
        url: "/usuarios",
        name: "Usuários",
        slug: "usuarios",
        icon: "UsersIcon"
      },
      {
        url: "/configuracoes",
        name: "Configurações",
        slug: "config",
        icon: "ConfIcon"
      }
    ]
  },
  {
    url: null,
    name: "Gestão",
    slug: "gestao",
    icon: "LayersIcon",
    submenu: [
      {
        url: "/reclamacoes",
        name: "Reclamações",
        slug: "reclamacoes",
        icon: "XOctagonIcon"
      },
      {
        url: "/avisos",
        name: "Notificação",
        slug: "notificacao",
        icon: "AlertTriangleIcon"
      }
    ]
  },
  {
    url: null,
    name: "Clientes",
    slug: "clientes",
    icon: "UsersIcon",
    submenu: [
      {
        url: "/clientes/cadastro",
        name: "Cadastro",
        slug: "cliCadastro",
        icon: "LifeBuoyIcon"
      }
    ]
  },
  {
    url: null,
    name: "Comercial",
    slug: "gestao",
    icon: "DollarSignIcon",
    submenu: [
      {
        url: "/gestao/comercial/comissoes",
        name: "Comissões",
        slug: "comissoes",
        icon: "DollarSignIcon"
      },
      {
        url: "/gestao/comercial/efetividade",
        name: "Efetividade",
        slug: "efetividade",
        icon: "TrendingUpIcon"
      }
    ]
  },
  {
    url: null,
    name: "Time de Apoio",
    slug: "gestao",
    icon: "LifeBuoyIcon",
    submenu: [
      {
        url: "/emails",
        name: "E-mails (Whitelist)",
        slug: "emails",
        icon: "DatabaseIcon"
      },
      {
        url: "/help-queries",
        name: "Chats",
        slug: "tools",
        icon: "ConfigIcon"
      },
    ]
  },
  {
    url: null,
    name: "Desenvolvimento",
    slug: "desenvolvimento",
    icon: "TerminalIcon",
    submenu: [
      {
        url: "/queries",
        name: "Queries",
        slug: "queries",
        icon: "DatabaseIcon"
      }
    ]
  }
];
